import type { FC, SVGProps } from 'react';

const RombIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.54941 0.434679C8.96984 -0.144892 8.03017 -0.144894 7.45059 0.434678L0.934679 6.95059C0.355108 7.53016 0.355106 8.46983 0.934678 9.04941L7.45059 15.5653C8.03016 16.1449 8.96983 16.1449 9.54941 15.5653L16.0653 9.04941C16.6449 8.46984 16.6449 7.53017 16.0653 6.95059L9.54941 0.434679ZM8.1502 1.13428C8.34339 0.941093 8.65661 0.941093 8.8498 1.13428L15.3657 7.6502C15.5589 7.84339 15.5589 8.15661 15.3657 8.3498L8.8498 14.8657C8.65661 15.0589 8.34339 15.0589 8.1502 14.8657L1.63428 8.3498C1.44109 8.15661 1.44109 7.84339 1.63428 7.6502L8.1502 1.13428Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RombIcon;
